import { dispatch } from '@angular-redux/store';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseAction } from './baseAction';
import { Account, AuthData } from "sharedFeatures/sharedModels";

export class accountActions {
    static readonly GET_AUTH_DATA = 'GET_AUTH_DATA';
    static readonly GET_AUTH_DATA_LOAD_START = 'GET_AUTH_DATA_LOAD_START';
    static readonly GET_AUTH_DATA_SUCCESS = 'GET_AUTH_DATA_SUCCESS';
    static readonly GET_AUTH_DATA_ERROR = 'GET_AUTH_DATA_ERROR';

    static readonly GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA';
    static readonly GET_ACCOUNT_DATA_LOAD_START = 'GET_ACCOUNT_DATA_LOAD_START';
    static readonly GET_ACCOUNT_DATA_SUCCESS = 'GET_ACCOUNT_DATA_SUCCESS';
    static readonly GET_ACCOUNT_DATA_ERROR = 'GET_ACCOUNT_DATA_ERROR';

    static readonly SET_SUBSCRIPTION_DOWNGRADE_ACTIVE = 'SET_SUBSCRIPTION_DOWNGRADE_ACTIVE';
    static readonly SET_LAST_ID_ORGANIZATION = 'SET_LAST_ID_ORGANIZATION';
    static readonly SET_SUBSCRIPTION_DOWNGRADE_DATE = 'SET_SUBSCRIPTION_DOWNGRADE_DATE';
    static readonly SET_SUBSCRIPTION_PRICE_OPTION1 = 'SET_SUBSCRIPTION_PRICE_OPTION1';
    static readonly SET_SUBSCRIPTION_PRICE_OPTION2 = 'SET_SUBSCRIPTION_PRICE_OPTION2';

    static readonly SET_UI_STATE = 'SET_UI_STATE';
    static readonly SET_OPENED_UI_STATE = 'SET_OPENED_UI_STATE';

    static readonly SET_COMPANY_CHANGED = 'SET_COMPANY_CHANGED';

    @dispatch()
    public static getAuthData(handleLastPlan: string): BaseAction {
        this.authDataLoadStarted();
        return { type: this.GET_AUTH_DATA, payload: handleLastPlan };
    }

    @dispatch()
    public static authDataLoadStarted(): BaseAction {
        return { type: this.GET_AUTH_DATA_LOAD_START };
    }

    public static authDataLoadSucceeded(authData: AuthData): BaseAction {
        return { type: this.GET_AUTH_DATA_SUCCESS, payload: authData };
    }

    public static authDataLoadFailed(error: HttpErrorResponse): BaseAction {
        return { type: this.GET_AUTH_DATA_ERROR, payload: error };
    }

    @dispatch()
    public static getAccountData(): BaseAction {
        this.accountDataLoadStarted();
        return { type: this.GET_ACCOUNT_DATA };
    }

    @dispatch()
    public static accountDataLoadStarted(): BaseAction {
        return { type: this.GET_ACCOUNT_DATA_LOAD_START };
    }

    public static accountDataLoadSucceeded(accountData: Account): BaseAction {
        return { type: this.GET_ACCOUNT_DATA_SUCCESS, payload: accountData };
    }

    public static accountDataLoadFailed(error: HttpErrorResponse): BaseAction {
        return { type: this.GET_ACCOUNT_DATA_ERROR, payload: error };
    }

    @dispatch()
    public static setSubscriptionDowngradeActive(isSubscriptionDowngradeActive: boolean): BaseAction {
        return { type: this.SET_SUBSCRIPTION_DOWNGRADE_ACTIVE, payload: isSubscriptionDowngradeActive };
    }

    @dispatch()
    public static setRemovedOrganizationFlag(lastIdOrganization: number | null): BaseAction {
        return { type: this.SET_LAST_ID_ORGANIZATION, payload: lastIdOrganization };
    }

    @dispatch()
    public static setSubscriptionDowngradeDate(downgradeDate: string): BaseAction {
        return { type: this.SET_SUBSCRIPTION_DOWNGRADE_DATE, payload: downgradeDate };
    }

    @dispatch()
    public static setSubscriptionPriceOption1(subscriptionPriceOption1: string): BaseAction {
        return { type: this.SET_SUBSCRIPTION_PRICE_OPTION1, payload: subscriptionPriceOption1 };
    }

    @dispatch()
    public static setSubscriptionPriceOption2(subscriptionPriceOption2: string): BaseAction {
        return { type: this.SET_SUBSCRIPTION_PRICE_OPTION2, payload: subscriptionPriceOption2 };
    }

    @dispatch()
    public static setUIState<T = any>(UIState: T): BaseAction {
        return { type: this.SET_UI_STATE, payload: UIState };
    }

    @dispatch()
    public static setOpenedUIState(openedUIState: any): BaseAction {
        return { type: this.SET_OPENED_UI_STATE, payload: openedUIState };
    }

    @dispatch()
    public static setCompanyChanged(): BaseAction {
        return { type: this.SET_COMPANY_CHANGED };
    }
}
